/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: slider.ts
 * Class: slider.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { SliderMarker } from '../component/ui/slider/types/SliderTypes';

const SLIDER_MAX_STEPS = 25;

function getSliderLogarithm(minimum: number, maximum: number, percentagePosition: number): number {
  const sliderMinPercentage = 0;
  const sliderMaxPercentage = 100;

  return Math.exp(
    Math.log(minimum)
        + (Math.log(maximum) - Math.log(minimum)) / (sliderMaxPercentage - sliderMinPercentage)
        * (percentagePosition - sliderMinPercentage),
  );
}

export function calculateSliderSteps(minimum: number, maximum: number): Array<SliderMarker> {
  let steps: Array<SliderMarker> = [];

  // --- less than X steps
  if (maximum - minimum <= SLIDER_MAX_STEPS) {
    for (let i = minimum; i <= maximum; i++) {
      steps.push({
        id: i,
        value: i,
        percentage: (maximum / minimum) * 100,
      });
    }
  } else {
    for (let i = 0; i <= SLIDER_MAX_STEPS; i++) {
      const percentagePosition: number = i / SLIDER_MAX_STEPS * 100;

      steps.push({
        id: i,
        percentage: percentagePosition,
        value: Math.round(
          getSliderLogarithm(minimum, maximum, percentagePosition),
        ),
      });
    }
  }

  // --- cleanup multiple identical values
  steps = steps.filter(
    (marker, index, list) => index === list.findIndex(
      (c) => c.value === marker.value,
    ),
  );

  // --- adjust percentages because of the previous filtering
  steps.forEach((marker, index, list) => marker.percentage = index / (list.length - 1) * 100);

  return steps;
}
